// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"862a75a8eeedda3802ba","293":"69b92d3ba19144d79750","518":"604032cb6c90f2de57be","779":"a2ef01dd3e5edde07a24"}[chunkId] + ".js";
};